import React from 'react';
import PropTypes from 'prop-types';

class Selection extends React.Component {
  static propTypes = {
    index: PropTypes.string,
    details: PropTypes.shape({
      name: PropTypes.string,
      position: PropTypes.string,
      salary: PropTypes.number,
      type: PropTypes.string,
    })
  }

  handleClick = (event) => {
    const playerKey = this.props.index;
    this.props.removePlayer(playerKey, parseFloat(this.props.details.salary))
  }

  render () {
    const { name, position, salary, type } = this.props.details;
    return (
      <div className="selection clearfix">
      <p>
        <span>{name},</span>&nbsp;
        <span>{position}</span>,&nbsp;
        {type === 'draft' ? <span>Draft</span>: <span>$<span>{salary}</span>m</span>}
      </p>
        <button onClick={this.handleClick}><span className="button-icon">&times;</span> <span className="button-text">Remove</span> </button>
      </div>
    )
  }
}

export default Selection;